// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3005977","239":"d9d04dfb","453":"0098adef","455":"1d28728a"}[chunkId] + ".chunk.js";
};